module.exports = "../../app/cells/pages/discipline/cta_discipline_matters_cell.rb";